import type { App, Component } from "vue";
import { createApp } from "vue";
import { createPinia } from "pinia";
import FontAwesomeIcon from "./fontawesome-icons";
import vClickOutside from "v-click-outside";
import VueGtag from "vue-gtag";
import { setupRouter } from "./routes";
import piniaPluginPersistedstate from "pinia-plugin-persistedstate";
import { setCookie } from "@/shared/helpers/cookieHelper";
import { CookieTypes } from "@/Models/CookieTypes";
import "@progress/kendo-theme-bootstrap/dist/all.css";
import "@/assets/kendo-overrides.scss";
import "@/assets/oudirect.scss";
import { useSentry } from "@/shared/sentry/useSentry";

function setupEmailLinkCookie() {
  if (!window.location.search.includes("emailLink=YF")) return;

  const returnUrl = window.location.href;
  setCookie(CookieTypes.EmailLink, returnUrl, 60 * 60 * 24 * 7); // 7 days
}

export function createPage(rootComponent: Component) {
  const app = createApp(rootComponent) // root component of our Vue app.
    .component("FontAwesomeIcon", FontAwesomeIcon); // register this component globally

  const pinia = createPinia();
  pinia.use(piniaPluginPersistedstate);
  app.use(pinia); // plugin

  // Limit error handling to production
  // For more clear callstacks
  if (import.meta.env.MODE !== "development") {
    app.config.errorHandler = (err: unknown) => {
      console.error("create-page.ts => vue error = " + err);
    };
  }

  const { bind, unbind } = vClickOutside.directive;

  app.directive("click-outside", {
    mounted(el, bindling) {
      bind(el, { value: bindling.value });
    },
    beforeUnmount(el) {
      unbind(el);
    },
  });

  app.use(VueGtag, {
    config: {
      id: "G-SW0LDJKY3B",
    },
  });

  const { setupSentryAsync } = useSentry(app);
  setupSentryAsync();
  setupRouter(app);
  setupEmailLinkCookie();

  app.mount("#app");
}
